import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Reminders } from '@etoh/database/angular';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserService } from '../../../../user.service';
import { StoreService } from '../../../store.service';

import { CommonModule } from '@angular/common';
import { subMinutes } from 'date-fns';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { UsersService } from '../../../users.service';

@Component({
  selector: 'etoh-reminders-upsert',
  templateUrl: './reminders-upsert.component.html',
  styleUrls: ['./reminders-upsert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NzButtonModule,
    FormlyModule,
    NzFormModule,
  ],
})
export class RemindersUpsertComponent implements OnInit {
  loading = false;
  form = new FormGroup({});

  @Input() model: Partial<Reminders> = {};

  fields: FormlyFieldConfig[];

  @Output() saved = new EventEmitter<number>();

  constructor(
    private storeService: StoreService,
    private userService: UserService,
    private message: NzMessageService,
    private cd: ChangeDetectorRef,
    private usersService: UsersService
  ) {}

  ngOnInit(): void {
    this.fields = [
      {
        key: 'title',
        type: 'input',
        props: {
          label: 'Title',
          placeholder: 'Enter title',
          required: true,
        },
      },
      {
        key: 'description',
        type: 'textarea',
        props: {
          label: 'Description',
          placeholder: 'Enter description',
          required: false,
        },
      },
      {
        key: 'startDate',
        type: 'datepicker',
        props: {
          disabledDate: (value: Date): boolean => {
            return value.getTime() < subMinutes(new Date(), 60).getTime();
          },
          showTime: true,
          label: 'Date',
          type: 'datetime-local',
          placeholder: 'Choose a datetime',
          required: true,
        },
      },
      {
        key: 'assignedTo',
        type: 'select',
        defaultValue: this.userService.userId$.value,
        props: {
          label: 'Assigned to',
          placeholder: 'Choose someone',
          required: true,
          options: this.usersService.getBrokersForOptions$(),
        },
      },
    ];
  }

  public onSubmit(model: any) {
    this.loading = true;

    if (this.model.id) {
      this.storeService
        .updateObjectByPk('reminders', this.model.id, this.model)
        .subscribe(() => {
          this.message.create(
            'success',
            `Reminder has been updated successfully`
          );
          this.loading = false;
          this.cd.detectChanges();
          this.saved.emit(this.model.id);
        });
    } else {
      this.storeService.addObject('reminders', this.model).subscribe((res) => {
        this.message.create('success', `Reminder has been added successfully`);
        this.loading = false;
        this.cd.detectChanges();
        this.saved.emit(res?.returning?.[0]?.['id']);
      });
    }
  }
}
